// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-above-or';

export const Component = () => (
  <path d='m18.918 6.556-3.927 3.928.718.67 4.407-4.359.67-.718L15.709 1l-.718.67 3.927 3.928H0v.957h18.918v.001Zm4.645 17.672V14.41h.958v9.818h-.958Zm-4.933 0V14.41h1.006v9.818H18.63Z' />
);

export const viewBox = '0 0 25 25';
